class FooterBlock extends HTMLElement {
    constructor() {
        super();
        this.isMobile = new DeviceWidth().isMobile;
        this.isiPadPro = window.matchMedia(
            'only screen and (min-width: 1024px) and (max-height: 1366px) and (-webkit-min-device-pixel-ratio: 1.5) and (hover: none)'
        ).matches;
        this.titleSelector = '.accordion-title';
    }

    connectedCallback() {
        if (this.isMobile || this.isiPadPro ) {
            const accordionBody = this.querySelector('.accordion-body');
            if (accordionBody) {
                accordionBody.style.transition = 'max-height 0.3s ease';
                const title = this.querySelector(this.titleSelector);
                if (title) {
                    title.addEventListener('click', () => {
                        this.toggleOpenState(accordionBody);
                    });
                }
            }
        }
    }

    toggleOpenState(accordionBody) {
        const isOpen = this.hasAttribute('open');
        if (isOpen) {
            accordionBody.style.maxHeight = null;
            this.removeAttribute('open');
        } else {
            document.querySelectorAll('footer-block').forEach((element) => {
                const body = element.querySelector('.accordion-body');
                if (element !== this && body && element.hasAttribute('open')) {
                    body.style.maxHeight = null;
                    element.removeAttribute('open');
                }
            });
            accordionBody.style.maxHeight = accordionBody.scrollHeight + 'px';
            this.setAttribute('open', '');
        }
    }
}

customElements.define('footer-block', FooterBlock);
